<template>
  <div class="page-container">
    <section id="section__confirm" class="view-container">
      <div class="width-100">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="font--p-3 mt-5 mb-2">
              신용 인증이 필요해요 <br />
              간편 조회 버튼을 눌러주세요
            </p>
            <v-col cols="12" class="mb-10 pa-0">
              <ul class="font-size--14 color--nice-grey outer">
                <li>신용평점 390점 미만 및 현재 연체가 있을 시 서비스 가입이 제한됩니다.</li>
                <li>서비스 가입을 위해 진행되는 조회는 신용평점에 영향을 주지 않습니다.</li>
              </ul>
            </v-col>

            <v-footer fixed>
              <v-layout class="px-2">
                <BasicButton
                  v-ripple
                  class="button next-button"
                  :disabled="isLoading"
                  :loading="isLoading"
                  @click="next"
                  type="button"
                >
                  간편 조회
                </BasicButton>
              </v-layout>
            </v-footer>
          </v-col>
        </v-row>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { sleep } from '@/util'
export default {
  created() {
    _meta({
      titles: ['신용평가'],
    })
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('evaluation', ['addCreditEvaluations']),
    async next() {
      const { redirectPath } = this.$route.query
      try {
        this.isLoading = true
        await this.addCreditEvaluations({
          redirectPath,
        })
        await sleep(5000)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#section__confirm {
  .v-card {
    background-color: #f4faff;
  }
}
</style>
